import type {
  DepartmentHealthBenchmarks,
  DepartmentHealthDimension,
  DepartmentHealthDimensionScores,
} from '../../types/DepartmentHealthTypes';

export const getDepartmentHealthBenchmarkReferenceScores = (
  benchmarks: DepartmentHealthBenchmarks,
): DepartmentHealthDimensionScores => {
  if (benchmarks.mixedRoles) {
    return benchmarks.companyAverage;
  }

  return benchmarks.roleNorm ?? benchmarks.companyAverage;
};

export const getDepartmentHealthBenchmarkReference = (
  benchmarks: DepartmentHealthBenchmarks,
  dimension: DepartmentHealthDimension,
): number | null => getDepartmentHealthBenchmarkReferenceScores(benchmarks)[dimension];
